import { useFormContext } from "react-hook-form";
import { FieldSetInputProps, FieldButton } from "components/voc";
import { useFormData } from "hooks";
import styled from "styled-components";
import React, { useState } from "react";

const FileWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  input[type="file"] {
    opacity: 0;
    position: absolute;
    height: 0;
    width: 0;
  }

  label {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0.6rem 1.2rem;
    border: 1px solid #c8d2e0;
    border-radius: 0.5rem;
    color: #454557;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }

  & + .form_validation {
    margin-top: 0;
  }
`;

type FieldFileProps = FieldSetInputProps;
const FieldFile = ({ name, multiple = true, ...props }: Omit<FieldFileProps, "onChange">) => {
  const { register, setValue } = useFormContext();

  const fileData = useFormData();
  const [files, setFiles] = useState<File[]>([]);

  const onChangeFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files as FileList;
    if (fileData.checkLimit(files, 20)) {
      window.alert("첨부 파일의 최대 용량은 20MB 입니다.");
      setFiles([]);
      setValue(name!, undefined);
      return;
    }
    const targetFiles = Array.from(files);
    setFiles(targetFiles);
  };

  const handleDelete = (payload: string) => {
    const dataTransfer = new DataTransfer();
    const fileList = files;
    const deleted = fileList.filter((x) => x.name !== payload);
    setFiles(deleted);

    deleted.map((el, _) => {
      dataTransfer.items.add(el);
    });

    setValue(name!, dataTransfer.files);
  };

  const { onChange, ...fieldRegister } = register(name!);

  return (
    <>
      <FileWrapper>
        <>
          <input {...fieldRegister} multiple={multiple} {...props} onChange={onChangeFiles} />
          <label htmlFor={props.id}>파일첨부</label>
        </>
      </FileWrapper>
      <ul className="list_file">
        {[...files].map((el: File, idx) => {
          const file = fileData.splitFileName(el);
          return (
            <li key={idx}>
              <p className="filename">
                <span className="txt">{file.name}</span>.{file.extension}
              </p>
              <FieldButton type="button" className="btn_delete_file" onClick={() => handleDelete(el.name)}>
                삭제
              </FieldButton>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default FieldFile;
